import { usePostHogFeatureFlag } from "~/hooks/usePostHogFeatureFlag";
import { useUserRole } from "~/hooks/trainer/useUserRole";
import { AppStats } from "~/modules/Dashboard/AppStats/AppStats";
import { SalesRepDashboard } from "~/modules/Dashboard/SalesRepDashboard/SalesRepDashboard";
import { TeamMemberDashboard } from "~/modules/Dashboard/TeamMemberDashboard/TeamMemberDashboard";
import { SALES_CRM_FEATURE_FLAG } from "~/modules/Sales/salesFeatureFlag";

// Wybór pulpitu startowego celowo zostaje po roli — to decyzja produktowa
// „na czym ma wylądować dana osoba", a nie bramka dostępu. Sprawdzone przy
// sweepie TRE-1855 i zostawione świadomie.
export default function Home() {
  const { isTeamMember, isTrainer, isSalesRep } = useUserRole();
  const { enabled: isSalesCrmFeatureEnabled } = usePostHogFeatureFlag(SALES_CRM_FEATURE_FLAG);

  if (isSalesRep && isSalesCrmFeatureEnabled) {
    return <SalesRepDashboard />;
  }

  if (isTeamMember) {
    return <TeamMemberDashboard />;
  }

  if (isTrainer) {
    return <AppStats />;
  }

  return <main className="flex flex-col gap-6" />;
}
